import { createSlice } from "@reduxjs/toolkit";
import { setInitialState } from "../../../store/InitialState";

const INITIAL_STATE = setInitialState({
	data: null,
	isFetching: false,
	isSuccess: false,
	isError: false,
	error: null,
});

const bulkDeleteActionSlice = createSlice({
	name: "bulkDeleteActionSlice",
	initialState: INITIAL_STATE,
	reducers: {
		bulkDeleteActionRequest: (state) => {
			state.isFetching = true;
		},
		bulkDeleteActionSuccess: (state, action) => {
			state.isFetching = false;
			state.isSuccess = true;
			state.data = action.payload;
		},
		bulkDeleteActionFailuer: (state, action) => {
			state.isFetching = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.payload;
		},
		resetBulkDeleteAction: (state) => {
			state.data = null;
			state.error = null;
			state.isError = false;
			state.isFetching = false;
			state.isSuccess = false;
		},
	},
});

// Exporting actions for saga and views
export const {
	bulkDeleteActionRequest,
	bulkDeleteActionSuccess,
	bulkDeleteActionFailuer,
	resetBulkDeleteAction,
} = bulkDeleteActionSlice.actions;

export default bulkDeleteActionSlice.reducer;
